import React, { useState, useMemo, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import SearchComponent from "../../components/Search";
import PaginationComponentOne from "../../components/Pagination/Pagination-O";
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSalesRecords } from "../../redux/Inventory/inventoryActions";
import EmptyState from "../../components/EmptyState";
import moment from "moment";


const SalesRecordsTab = ({ activeTab }) => {
  const [searchValue, setSearchValue] = useState("");
  const [tableFilter, setTableFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchParams] = useSearchParams();
  const variant = searchParams.get('variant');
  const dispatch = useDispatch();
  const { salesRecords, loading, salesRecordsTotalCount } = useSelector((state) => state.inventory);
  

  const handlePageChange = (paginationData) => {
    // Carbon's Pagination component passes an object with page and pageSize
    if (typeof paginationData === 'object') {
      if (paginationData.page !== undefined) {
        setPage(paginationData.page);
      }
      if (paginationData.pageSize !== undefined && paginationData.pageSize !== pageSize) {
        setPageSize(paginationData.pageSize);
        setPage(1); // Reset to first page when page size changes
      }
    } else {
      setPage(paginationData);
    }
  };

  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        setPage(1); // Reset to first page on search
      }, 500),
    []
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  useEffect(() => {
      // Only dispatch if variant is available
      if (variant) {
        dispatch(fetchSalesRecords({
          variantId: variant,
          status: tableFilter,
          search: searchValue || undefined,
          page: page,
          page_size: pageSize
        }));
      }
   }, [dispatch, variant, tableFilter, searchValue, page, pageSize]);

  return (
    <div className="mt-5 bg-white rounded-[8px] border border-[#E1E6E1] py-4 px-4 col-span-3">
      {/* search section */}
      <div className="mt-4">
        <SearchComponent
          placeholder="Search by Order ID, Channel"
          searchValue={searchValue}
          handleChange={handleChange}
        />
      </div>
      {/* Table Filters */}
      <div className="pb-3 w-full border-b border-[#E1E6E1]">
        <div className="text-sm font-semibold text-[#3E473F] border border-[#E1E6E1] mt-3  max-w-[576px] rounded-lg overflow-hidden flex">
          <button
            className={`px-3 py-2 text-center gap-2 flex items-center justify-center flex-1 ${
              tableFilter === "all" ? "bg-white rounded-lg" : "bg-[#F6F7F6]"
            }`}
            onClick={() => {
              setTableFilter("all");
              setPage(1);
            }}
          >
            {" "}
            All
            <p
              className={`text-xs px-1 py-0.5 w-fit rounded-[4px] ${
                tableFilter === "all"
                  ? "bg-[#DBFFDF] text-[#3E473F]"
                  : "bg-[#F6F7F6] text-[#5F6D60] border border-[#5C715E]"
              } font-semibold`}
            >
              {tableFilter === "all" ? salesRecords.length : 0}
            </p>
          </button>
          <button
            className={`px-3 py-2 text-center gap-2 flex items-center justify-center flex-1 ${
              tableFilter === "processing"
                ? "bg-white rounded-lg"
                : "bg-[#F6F7F6]"
            }`}
            onClick={() => {
              setTableFilter("processing");
              setPage(1);
            }}
          >
            {" "}
            Processing
            <p
              className={`text-xs px-1 py-0.5 w-fit rounded-[4px] ${
                tableFilter === "processing"
                  ? "bg-[#DBFFDF] text-[#2B8C34]"
                  : "bg-[#F6F7F6] text-[#5F6D60] border border-[#5C715E]"
              } font-semibold`}
            >
                {tableFilter === "processing" ? salesRecords.length : 0}
            </p>
          </button>
          <button
            className={`px-3 py-2 text-center gap-2 flex items-center justify-center flex-1 ${
              tableFilter === "delivered"
                ? "bg-white rounded-lg"
                : "bg-[#F6F7F6]"
            }`}
            onClick={() => {
              setTableFilter("delivered");
              setPage(1);
            }}
          >
            {" "}
            Delivered
            <p
              className={`text-xs px-1 py-0.5 w-fit rounded-[4px] ${
                tableFilter === "delivered"
                  ? "bg-[#DBFFDF] text-[#2B8C34]"
                  : "bg-[#F6F7F6] text-[#5F6D60] border border-[#5C715E]"
              } font-semibold`}
            >
              {tableFilter === "delivered" ? salesRecords.length : 0}
            </p>
          </button>
          <button
            className={`px-3 py-2 text-center gap-2 flex items-center justify-center flex-1 ${
              tableFilter === "cancelled"
                ? "bg-white rounded-lg"
                : "bg-[#F6F7F6]"
            }`}
            onClick={() => {
              setTableFilter("cancelled");
              setPage(1);
            }}
          >
            {" "}
            Cancelled
            <p
              className={`text-xs px-1 py-0.5 w-fit rounded-[4px] ${
                tableFilter === "cancelled"
                  ? "bg-[#DBFFDF] text-[#2B8C34]"
                  : "bg-[#F6F7F6] text-[#5F6D60] border border-[#5C715E]"
              } font-semibold`}
            >
              {tableFilter === "cancelled" ? salesRecords.length : 0}
            </p>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto relative mb-3 py-4">
        
         {
              loading
              ?
              <div className="animate-pulse w-full mb-4">
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
                <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
              </div>
              :
              !salesRecords || salesRecords.length === 0
              ?
              <div className="">
                <EmptyState text="No sales record data available yet!" />
              </div>
              :
              <>
               <table className="w-full text-left rounded-lg overflow-hidden border border-[#E1E6E1]">
                <thead className="bg-[#F6F7F6] border-[#E1E6E1]">
                  <tr className="text-sm ">
                    <th className="px-4 py-4 font-semibold text-[#5F6D60] rounded-tl-lg rounded-bl-lg  ">
                      Order ID
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60]"
                    >
                      Store Name
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60]"
                    >
                      Location
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60]"
                    >
                      Channel
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60]"
                    >
                      Amount
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60]"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-4 font-semibold text-[#5F6D60] rounded-tr-lg rounded-br-lg"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                    <tbody className="bg-white border-[#E1E6E1]">
            {/* Make route dynamic here */}
            {salesRecords.map((product) => (
              <tr
                key={product.order_id}
                className="text-sm cursor-pointer hover:bg-[#EDF7EE] border-b border-[#E1E6E1]"
              >
                <td className="px-4 py-4 flex font-normal text-[#5F6D60] whitespace-nowrap ">
                  <p className=" py-1 px-0.5 border-[#E1E6E1] rounded-md font-semibold">
                    {product.order_id}
                  </p>
                </td>
                <td className=" px-4 py-4 text-[#5F6D60] font-semibold">
                  {product?.store_name || 'N/A'}
                </td>

                <td className=" px-4 py-4 text-[#5F6D60] font-semibold">
                  {product?.location_name || 'N/A'}
                </td>
                <td className="px-4 py-4 text-[#5F6D60]">
                  <p className="border w-fit py-1 px-2 capitalize rounded-md font-medium ">
                    {product.channel}
                  </p>
                </td>

                <td className="px-4 py-4 text-[#5F6D60]">
                  <p className="border w-fit py-1 px-2 rounded-md font-medium ">
                    ₦{product.amount}
                  </p>
                </td>

                <td className=" px-4 py-4 text-[#5F6D60] font-semibold">
                  {moment(product?.date).format("DD/MM/YYYY")}
                </td>

                <td className=" px-4 py-4">
                  <div className="relative">
                    <div
                      className={
                        product.status === "PROCESSING"
                          ? "processing-badge"
                          : product.status === "DISPATCHED"
                          ? "dispatched-badge"
                          : product.status === "CANCELLED"
                          ? "cancelled-badge"
                          : product.status === "REJECTED"
                          ? "cancelled-badge"
                          :  product.status === "PENDING"
                          ? "processing-badge"
                          : product.status === "ACCEPTED"
                          ? "delivered-badge"
                          : product.status === "ASSIGNED"
                          ? "delivered-badge"
                          : "noitem-badge"
                      }
                    >
                      <p className="capitalize">{product.status.toLowerCase()}</p>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
                 </tbody>
                 </table>
              </>
          }

        {/* Pagination */}
        {salesRecords && salesRecords.length > 0 && (
          <div className="border-t border-[#E1E6E1]">
            <PaginationComponentOne
              totalItems={salesRecordsTotalCount || 0}
              page={page}
              pageSize={pageSize}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesRecordsTab;
